import { createRegisteredContext } from 'react-singleton-context';
import { ELocale } from '@lumahealthhq/ui-model-types';
const UIUtilsContext = createRegisteredContext('UIUtilsContext', {
  config: {},
  locale: ELocale.EnglishUS,
  setLocale: () => {}
});
export default UIUtilsContext;